import { render, staticRenderFns } from "./iconRevission.vue?vue&type=template&id=876bdad8&scoped=true&lang=pug&"
import script from "./iconRevission.vue?vue&type=script&lang=js&"
export * from "./iconRevission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876bdad8",
  null
  
)

export default component.exports